import { SWRConfiguration } from "swr";

export const SwrGlobalConfig: SWRConfiguration = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  errorRetryCount: 0,
};
